<!-- Empty component file with data-cy tag for testing -->
<div data-cy="table-column-v2-container"></div>
